'use strict';

import {
    ShaderMaterial, Color,
} from 'three';
import { isMobile, projectMode, threeJsVariables } from '../../../settings';
import snowVertex from '../../threejs/Shaders/weather/snow/vertexShader.glsl';
import snowFragment from '../../threejs/Shaders/weather/snow/fragmentShader.glsl';
import { Weather } from './Weather';
import { Effect } from '../../post-processing/Passes/Effect';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { resetFogToDefault, setFogParams } from '../../post-processing/Passes/Fog';
import { OrbitDayAndNight } from '../../liveAnimations/DayNight/OrbitDayAndNight';

export class Snow {
    static #material;
    static #params = {
      layers: isMobile ? 15 : 50,
      depth: 0.5,
      width: 0.3,
      speed: 0.6,
      snowflakeSize: config.features?.weather?.settings?.snow?.flakeSize || 1,
      fogFar: config.features?.weather?.settings?.snow?.fogFar || 0.5
    };

    constructor () {
        this.fogColor = new Color(0.87,0.87,0.87);
        this.envFogDensity = 0.0025;
        this.bgFogDensity = 0.0025;

        Snow.#material = new ShaderMaterial({
            vertexShader: snowVertex,
            fragmentShader: snowFragment,
            uniforms: {
                tDiffuse: {
                  value: null
                },
                uLayers: {
                    value: Snow.#params.layers
                },
                uDepth: {
                    value: Snow.#params.depth
                },
                uWidth: {
                    value: Snow.#params.width
                },
                uSpeed: {
                    value: Snow.#params.speed
                },
                uTime: {
                    value: 0
                },
                uParticleSize: {
                    value: Snow.#params.snowflakeSize
                },
                uLiteMode: {
                    value: projectMode.LiteMode.isActive()
                }
            },
            depthWrite: false,
            depthTest: false
        });

        // this.effect = new PostFX('snow',threeJsVariables.renderer,Snow.#material);
        this.effect = new SnowEffect(Snow.#material);
        threeJsVariables.composer.addPass('snow',this.effect);

        this.#debug();

        return this;
    }

    enable() {
        if (!Weather.showed) return;
        this.effect.active = true;
    
        if (projectMode.LiteMode.isActive()) {
            projectMode.LiteMode.cloudsToggle('enable');
        } else {
            setFogParams({
                active: true,
                fogColor: "#dedede",
                fogDensity: 0.95,
                fogFar: Snow.#params.fogFar,
                fogNear: 1
            });
        }
    }

    disable() {
        this.effect.active = false;
    
        if (projectMode.LiteMode.isActive()) {
            projectMode.LiteMode.cloudsToggle('disable');
        } else {
            resetFogToDefault();
        }
    }

    #debug() {
        if (!projectMode.LiteMode.debug) return;

        const folder = projectMode.LiteMode.debugFolder.addFolder('Snow');

        folder.add(Snow.#params,'layers', 0, 100, 1).onChange(value => {
            Snow.#material.uniforms.uLayers.value = value;
        });

        folder.add(Snow.#params,'depth', 0.0, 2.0, 0.001).onChange(value => {
            Snow.#material.uniforms.uDepth.value = value;
        });

        folder.add(Snow.#params,'width', 0.0, 10.0, 0.001).onChange(value => {
            Snow.#material.uniforms.uWidth.value = value;
        });

        folder.add(Snow.#params,'speed', 0.0, 50.0, 0.001).onChange(value => {
            Snow.#material.uniforms.uSpeed.value = value;
        });
    }

    static setData(data) {
        if (!data.hasOwnProperty('snow')) return;

        Snow.#material.uniforms.uSpeed.value = 0.25 + data.snow.intensity;
    }

    static resetToDefault() {
        Snow.#material.uniforms.uSpeed.value = Snow.#params.speed;
    }

    update(time) {
        if (this.effect.active) {
            Snow.#material.uniforms.uTime.value = time;
        }
    }
}

class SnowEffect extends Effect{
    constructor (material) {
        super();
        this.effect = new ShaderPass(material);
        this.active = false;
    }

}
